import { CityType } from '../../types/cityType';

export const getFoodApiRouteUri = (city: CityType): string =>
    `food/get/${city}`;
